import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import {
  Avatar,
  Divider,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import { cyan } from '@mui/material/colors';
import { Box } from '@mui/system';

import { AppPath } from '@/shared/constants/path';
import User from '@/shared/types/user';

type CurrentUserSettingsButtonProps = {
  user: User;
  selected?: boolean;
};

const CurrentUserSettingsButton: FC<CurrentUserSettingsButtonProps> = ({
  user,
  selected = false,
}) => {
  return (
    <Box
      sx={{
        mx: -2,
        mb: 2,
        backgroundColor: selected ? cyan[50] : 'transparent',
      }}
    >
      <Divider />
      <ListItemButton
        component={NavLink}
        to={AppPath.Settings_UserSettings}
        sx={{
          borderRadius: 0,
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 0,
          }}
        >
          <ListItemAvatar>
            <Avatar
              alt='User Avatar'
              src={''}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: selected ? 'primary.main' : '',
              }}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                variant='body1'
                sx={{ color: selected ? 'primary.main' : 'text.primary' }}
              >
                {user.first_name} {user.last_name}
              </Typography>
            }
            secondary={
              <Typography
                variant='body2'
                component='span'
                sx={{
                  color: selected ? 'primary.main' : 'text.primary',
                }}
              >
                {user.email_address}
              </Typography>
            }
          />
        </Box>
      </ListItemButton>
      <Divider />
    </Box>
  );
};

export default CurrentUserSettingsButton;
